import { Button } from "@cntrl/ui";
import {
  useSaveTokenCommunicationPreferences,
  useTokenCommunicationPreferences,
} from "../../../app/hooks/useCommunicationPreferences.js";
import { AuthCard } from "../../auth/AuthCard.js";
import { CommunicationPreferences } from "./CommunicationPreferences.js";

export interface CommunicationPreferencesScreenProps {
  /** The token from a notification email's footer link. */
  token: string;
  /** The footer's "unsubscribe" link names its email's category: open on that category's confirm step. */
  unsubscribe?: string;
  onDone: () => void;
}

/**
 * `/settings/email?token=…` (ART-285) — where a notification email's footer links land. Outside the shell and signed
 * out is the ordinary case: the token, not a session, authorizes reading and changing that one person's switches. It
 * renders only the shared {@link CommunicationPreferences}; in the app the same component opens in a modal instead.
 */
export function CommunicationPreferencesScreen({ token, unsubscribe, onDone }: CommunicationPreferencesScreenProps) {
  const prefs = useTokenCommunicationPreferences(token);
  const save = useSaveTokenCommunicationPreferences(token);

  return (
    <AuthCard
      title="Communication preferences"
      footer={
        <Button variant="link" type="button" onClick={onDone}>
          Go to Artist CNTRL
        </Button>
      }
    >
      <CommunicationPreferences
        data={prefs.data}
        isLoading={token.length > 0 && prefs.isLoading}
        isError={!token || prefs.isError}
        errorMessage="This link isn't valid. Open Settings in the app to change your communication preferences."
        onSave={(changes) => save.mutateAsync(changes)}
        saving={save.isPending}
        unsubscribe={unsubscribe}
      />
    </AuthCard>
  );
}
